import {z} from 'zod';

export const usernameValidator = z.string().superRefine((val, ctx) => {
    const trimmed = val.trim();
    if (trimmed.length < 3) {
        ctx.addIssue({
            code: z.ZodIssueCode.too_small,
            minimum: 3,
            type: 'string',
            inclusive: true,
            message: 'registerPage.errorMessages.userNameShort',
        });
    }
    if (trimmed.length > 36) {
        ctx.addIssue({
            code: z.ZodIssueCode.too_big,
            maximum: 36,
            type: 'string',
            inclusive: true,
            message: 'registerPage.errorMessages.userNameLong',
        });
    }
});
